let prefixed = name => 'common/' + name
let qasPrefixed = name => 'qasmanagement/qas/' + name

// export const factoryCoo = qasPrefixed('getMasterFactoryCooList')
export const factory = qasPrefixed('getMasterFactoryList')
// export const qasBrand = prefixed('brands')
export const qasVendor = qasPrefixed('getMasterVendorList')
export const qasQARegion = qasPrefixed('getMasterQARegionList')
export const qasCountryPQA = qasPrefixed('getMasterCountryPQAList')
export const qasAuditStage = qasPrefixed('getMasterAuditStageList')
export const qasAuditStatus = qasPrefixed('getAuditStatusList')
export const qasAuditorName = qasPrefixed('getAuditorNameList')
export const qasHasMapping = qasPrefixed('getHasVendorMapping')
export const qasDefects = qasPrefixed('getDefectList')
export const qasAuditPoint = qasPrefixed('getAuditPointList')
export const qasUserAuditPoint = qasPrefixed('userAuditPointList')
export const qasFolder = qasPrefixed('getQasFolder')

export const qasLastUser = qasPrefixed('qasLastUser')

// export const isLoaded = prefixed('isLoaded')
export const initialize = prefixed('initialize')



// WEBPACK FOOTER //
// ./src/components/qas/common/store/definition.js